const CLIENT_ID_KEY = 'mb_client_id';
const FLOW_ID_KEY = 'mb_registration_flow_id';
const UTM_SOURCE_KEY = 'mb_reg_utm_source';
const UTM_CAMPAIGN_KEY = 'mb_reg_utm_campaign';
const UTM_MEDIUM_KEY = 'mb_reg_utm_medium';

function randomId(prefix: string): string {
  const rnd = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now().toString(36)}_${rnd}`;
}

function safeGetStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

function safeGetSessionStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function getOrCreateClientId(): string {
  const storage = safeGetStorage();
  const existing = storage?.getItem(CLIENT_ID_KEY);
  if (existing) return existing;
  const next = randomId('cli');
  storage?.setItem(CLIENT_ID_KEY, next);
  return next;
}

export function ensureRegistrationFlowId(): string {
  const storage = safeGetSessionStorage();
  const existing = storage?.getItem(FLOW_ID_KEY);
  if (existing) return existing;
  const next = randomId('reg');
  storage?.setItem(FLOW_ID_KEY, next);
  return next;
}

export function captureRegistrationTrackingFromSearch(search: string): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(search);
  const storage = safeGetSessionStorage();
  const clientStorage = safeGetStorage();

  const flowId = params.get('flow_id')?.trim();
  if (flowId) storage?.setItem(FLOW_ID_KEY, flowId);
  else ensureRegistrationFlowId();

  const clientId = params.get('client_id')?.trim();
  if (clientId) {
    clientStorage?.setItem(CLIENT_ID_KEY, clientId);
  } else {
    getOrCreateClientId();
  }

  const utmSource = params.get('utm_source')?.trim();
  const utmCampaign = params.get('utm_campaign')?.trim();
  const utmMedium = params.get('utm_medium')?.trim();

  if (utmSource) storage?.setItem(UTM_SOURCE_KEY, utmSource);
  if (utmCampaign) storage?.setItem(UTM_CAMPAIGN_KEY, utmCampaign);
  if (utmMedium) storage?.setItem(UTM_MEDIUM_KEY, utmMedium);
}

export function getRegistrationTrackingHeaders(): Record<string, string> {
  const sessionStorage = safeGetSessionStorage();
  const flowId = ensureRegistrationFlowId();
  const clientId = getOrCreateClientId();
  const utmSource = sessionStorage?.getItem(UTM_SOURCE_KEY) || '';
  const utmCampaign = sessionStorage?.getItem(UTM_CAMPAIGN_KEY) || '';
  const utmMedium = sessionStorage?.getItem(UTM_MEDIUM_KEY) || '';

  return {
    'X-Registration-Flow-Id': flowId,
    'X-Client-Id': clientId,
    ...(utmSource ? { 'X-Utm-Source': utmSource } : {}),
    ...(utmCampaign ? { 'X-Utm-Campaign': utmCampaign } : {}),
    ...(utmMedium ? { 'X-Utm-Medium': utmMedium } : {}),
  };
}
